import {
  ALL_TAED_INCOMING_OUTGOING_FILTERS,
  ALL_TAED_STATUS_FILTERS,
  INCOMING_FILTER,
  OUTGOING_FILTER,
  TAED_FILTER_DATE_TYPES
} from "../constants";
import { TODAY, YESTERDAY } from "../dateHelper";

export const DEFAULT_TEMP_ASSIGNMENT_DATE_TYPE_FILTER = TAED_FILTER_DATE_TYPES.ACTIVE_DATE;

export const DEFAULT_TEMP_ASSIGNMENT_START_DATE_FILTER = (station) => {
  return YESTERDAY(station);
};

export const DEFAULT_TEMP_ASSIGNMENT_END_DATE_FILTER = (station) => {
  return TODAY(station);
};

export const DEFAULT_INCOMING_OUTGOING_FILTERS = ALL_TAED_INCOMING_OUTGOING_FILTERS;

export const DEFAULT_TEMP_ASSIGNMENT_STATUS_FILTERS = ALL_TAED_STATUS_FILTERS;

export const DEFAULT_TEMP_ASSIGNMENT_SORT_MODEL = [
  {
    field: "status",
    sort: "asc",
  },
];

export function filterTempAssignments(
  tempAssignments,
  dateTypeFilter,
  startDateFilter,
  endDateFilter,
  stationFilter,
  incomingOutgoingFilters,
  statusFilters,
  workgroupFilters
) {
  let filteredTempAssignments = tempAssignments;
  filteredTempAssignments = filterOnDateType(filteredTempAssignments, dateTypeFilter, startDateFilter, endDateFilter);
  filteredTempAssignments = filterOnIncomingOutgoingFilters(
    filteredTempAssignments,
    incomingOutgoingFilters,
    stationFilter
  );
  filteredTempAssignments = filterOnStatusFilters(filteredTempAssignments, statusFilters);
  filteredTempAssignments = filterOnWorkgroupFilters(filteredTempAssignments, workgroupFilters);
  return filteredTempAssignments;
}

export function filterOnDateType(filteredTempAssignments, dateTypeFilter, startDateFilter, endDateFilter) {
  if (dateTypeFilter) {
    if (dateTypeFilter === TAED_FILTER_DATE_TYPES.ACTIVE_DATE) {
      filteredTempAssignments = filteredTempAssignments.filter(
        (tempAssignment) =>
          tempAssignment.endDate.toMillis() >= startDateFilter.toMillis() &&
          tempAssignment.startDate.toMillis() <= endDateFilter.toMillis()
      );
    } else if (dateTypeFilter === TAED_FILTER_DATE_TYPES.LAST_UPDATED_DATE) {
      filteredTempAssignments = filteredTempAssignments.filter(
        (tempAssignment) =>
          tempAssignment.lastUpdatedDate.toMillis() >= startDateFilter.toMillis() &&
          tempAssignment.lastUpdatedDate.toMillis() <= endDateFilter.toMillis()
      );
    } else if (dateTypeFilter === TAED_FILTER_DATE_TYPES.START_DATE) {
      filteredTempAssignments = filteredTempAssignments.filter((tempAssignment) => {
        return (
          tempAssignment.startDate.toMillis() >= startDateFilter.toMillis() &&
          tempAssignment.startDate.toMillis() <= endDateFilter.toMillis()
        );
      });
    } else if (dateTypeFilter === TAED_FILTER_DATE_TYPES.END_DATE) {
      filteredTempAssignments = filteredTempAssignments.filter((tempAssignment) => {
        return (
          tempAssignment.endDate.toMillis() >= startDateFilter.toMillis() &&
          tempAssignment.endDate.toMillis() <= endDateFilter.toMillis()
        );
      });
    }
  }
  return filteredTempAssignments;
}

export function filterOnIncomingOutgoingFilters(filteredTempAssignments, incomingOutgoingFilters, stationFilter) {
  if (incomingOutgoingFilters) {
    filteredTempAssignments = filteredTempAssignments.filter((tempAssignment) => {
      if (incomingOutgoingFilters.includes(INCOMING_FILTER) && incomingOutgoingFilters.includes(OUTGOING_FILTER)) {
        return tempAssignment.tempStation === stationFilter || tempAssignment.homeStation === stationFilter;
      } else if (incomingOutgoingFilters.includes(INCOMING_FILTER)) {
        return tempAssignment.tempStation === stationFilter;
      } else if (incomingOutgoingFilters.includes(OUTGOING_FILTER)) {
        return tempAssignment.homeStation === stationFilter;
      }
      return false;
    });
  }
  return filteredTempAssignments;
}

export function filterOnStatusFilters(filteredTempAssignments, statusFilters) {
  if (statusFilters) {
    filteredTempAssignments = filteredTempAssignments.filter((tempAssignment) =>
      statusFilters.includes(tempAssignment.status)
    );
  }
  return filteredTempAssignments;
}

export function filterOnWorkgroupFilters(filteredTempAssignments, workgroupFilters) {
  if (workgroupFilters) {
    filteredTempAssignments = filteredTempAssignments.filter((tempAssignment) =>
      workgroupFilters.includes(tempAssignment.workgroup)
    );
  }
  return filteredTempAssignments;
}
